import React, { useEffect, useState } from "react";
import "./OrderSelection.scss"
import deliveryIc from "../../../assets/delivery-cycle.svg"
import takawayIc from "../../../assets/takeaway.svg"
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../RestaurantWidget/utilities/helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedOrderType } from "../../../../../../../../redux/resturantWidgetSlice";
const OrderSelection = ({ setAddDeliveryLoc, setCollectionStore }) => {
    const defaultOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).defaultOrderType
    const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes

    const [selectedType, setSelectedType] = useState(defaultOrderType)
    useEffect(() => {
        sessionStorage.clear()
    }, [])
    const orderTypes = [
        { name: "Collection", type: "collection", icon: takawayIc, sub: "Pick up your order in store" },
        { name: "Delivery", type: "delivery", icon: deliveryIc, sub: "Get it delivered to your door" },
    ]
    const { companies } = useSelector((state) => state.companyData);
    const dispatch = useDispatch()
    const filteredData = orderTypes.filter(item => availableTypes?.includes(item.type));
    const handleType = () => {
        if (selectedType === "delivery") {
            setAddDeliveryLoc(true)
        } else {
            if (companies.length > 1) {
                setCollectionStore(true)
            } else {
                dispatch(setSelectedOrderType(selectedType))
            }
        }
    }
    return (
        <div className="OrderSelectionV4">
            <div className="header-text">Choose Your Order Type</div>
            <div className="sub-text">Select an option that best suits your preferences.</div>
            <div className="order-type-containers">
                {filteredData.map((orderType, index) => {
                    return (<div key={index}
                        className={`order-type-container ${selectedType === orderType.type ? 'selected' : ""}`}
                        onClick={() => {
                            setSelectedType(orderType.type)
                        }} >
                        <div className="order-type-container-left">
                            {selectedType === orderType.type ? <div className="radio-type-selected"><div className="radio-type-selected-inner" /></div> : <div className="radio-type" />}
                            <div className="order-text"
                            >{orderType.name}
                                <div className="sub-text-type">{orderType.sub}</div></div></div>
                        <div className="order-type-container-right"><img alt="" src={orderType.icon} /></div>

                    </div>)
                })}
            </div>
            <div className="proceed-btn" onClick={handleType}>Proceed</div>

        </div>
    )
}
export default OrderSelection